import { animate, query, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faEnvelope, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthService, SocialUser } from 'angularx-social-login';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';
import { RegisterRsComponent } from '../register-rs/register-rs.component';

declare const invokeCSharpAction: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('mailPassword', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ], { optional: true })
      ]),
    ])
  ]
})

export class LoginComponent implements OnInit {

  faPlus = faPlus;
  faEnvelope = faEnvelope;

  logIn: boolean;

  resultMessage: string;
  userInfo = '';
  mailPassword = false;
  loginFfv = false;
  ios = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private titleService: TitleService,
    private authenticationService: AuthenticationService,
    private dataService: DataService,
    private authService: SocialAuthService,
    private dialog: MatDialog,
    private uiService: UiService,
    private userService: UserService
  ) {
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/home']);
    }
  }

  ngOnInit(): void {
    this.checkRoute();
    // get return url from route parameters or default to '/'
    // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.titleService.title.next('Connexion');
    this.isLogIn();

    const isMobile = window.matchMedia('only screen and (max-width: 768px)');



    // /Android [0-9]?[0-9].[0-3].[0-9]/g.test(navigator.userAgent) ?
    //   this.ios = false :


    if (/iPhone|iPad|iPadPro|iPod/i.test(navigator.userAgent) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)) {
      this.ios = true;
    }
  }

  // /Android [0-9]?[0-9].[0-3].[0-9]/g.test(navigator.userAgent) ?
  // this.ios = false :
  // (navigator.userAgent.includes('Mac') && 'ontouchend' in document) ?
  //   this.ios = true : this.ios = false;

  invokeCS(type: string): void {
    invokeCSharpAction(type);
  }

  socialLogin(socialUser: SocialUser, platformType: string): void {
    // this.loading = true;
    this.userInfo = JSON.stringify(socialUser);
    this.dataService.jsonResauxSocial.next(socialUser);
    // this.show ? this.show = false : this.show = false;
    this.authenticationService.loginSocial(socialUser.authToken, socialUser.id, platformType, socialUser.email).subscribe(res => {
      const userInfos = this.authenticationService.getDecodedToken();
      this.router.navigate(['/']);
      this.dataService.isConnect.next(true);
      this.dataService.userLogin.next(userInfos);

    },
      err => {
        // this.dataService.socialEmail.next(socialUser.email);
        // this.dataService.socialFirstname.next(socialUser.firstName);
        // this.dataService.socialLastname.next(socialUser.lastName);
        // this.show ? this.show = false : this.show = false;
        // this.uiService.openSnackBar(`Finalisez votre inscription en remplissant les champs vides.`, '');
        // this.loading = false;

        socialUser.email === null ?
          this.uiService.openSnackBar('Connexion impossible - voir paramètres Facebook', '') :
          this.openDialog(socialUser, platformType);
        // this.uiService.openSnackBar(`Ce compte n'existe pas`, '');

      });
  }


  loginWithSocialMedia(platform: string): void {
    // Check if on mobile
    switch (platform) {
      case 'facebook':
        platform = FacebookLoginProvider.PROVIDER_ID;
        break;
      case 'google':
        platform = GoogleLoginProvider.PROVIDER_ID;
        break;
      case 'apple':
        platform = 'apple';
        break;

      default:
        break;
    }

    const platformType = platform.toLocaleLowerCase();
    this.authService.signIn(platform).then(
      (response) => {
        this.socialLogin(response, platform);


      },
      (error) => {
        this.resultMessage = error;
      });
    invokeCSharpAction(platform.toLowerCase());
  }

  private checkRoute(): void {
    this.route.queryParams.subscribe(params => {
      if (params.userinfo) {
        const user: SocialUser = JSON.parse(decodeURIComponent(escape(atob(params.userinfo)))); // JSON.parse(atob(params.userinfo));
        this.socialLogin(user, user.provider.toLowerCase());
      }
    });
  }

  private openDialog(socialUser: SocialUser, platformType: string): void {
    const dialogRef = this.dialog.open(RegisterRsComponent, { data: socialUser });

    dialogRef.afterClosed().subscribe(result => {
      if (socialUser.provider === 'apple') {
        this.socialLogin(socialUser, socialUser.provider.toLowerCase());

      }
    });
  }


  private isLogIn(): void {
    this.logIn = this.dataService.isLogIn(this.authenticationService.currentUserValue);
    this.logIn ? this.router.navigate(['/']) : this.router.navigate(['/login']);
  }

}
